import { datadogRum } from '@datadog/browser-rum';
import auth from './../authfile';

const useLogout = async () => {
  const { data, error } = await useAcvFetch('/api/user/logout');

  if (error.value) {
    // replace with datadog error log
    console.log('logout fail:', error.value);
  }

  const config = useRuntimeConfig();
  const auth0 = await auth(
    config.public.AUTH0_DOMAIN,
    config.public.AUTH0_CLIENT_ID,
    config.public.REDIRECT_URL
  );

  datadogRum.clearUser();

  await auth0.logout({
    returnTo: window.location.origin,
  });

  // remove user details to ensure a new user object is generated on login
  if (localStorage.getItem('user')) {
    localStorage.removeItem('user');
  }
};

export default useLogout;
